"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAddedToOrganizationMessage = void 0;
const workerMessage_1 = require("./workerMessage");
const model_1 = require("../model");
class UserAddedToOrganizationMessage extends workerMessage_1.WorkerMessage {
    constructor(user, inviterUser, organization) {
        super(model_1.QueueDefinitions.USER_ADDED_TO_ORGANIZATION_MESSAGE);
        this.user = user;
        this.inviterUser = inviterUser;
        this.organization = organization;
    }
}
exports.UserAddedToOrganizationMessage = UserAddedToOrganizationMessage;
